import React from 'react';

export interface IconProps {
  className?: string;
}

export const DoneIcon: React.FC<IconProps> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" className={className}>
        <path fill="#35D48D" fillRule="evenodd" d="M4.494 8a.53.53 0 0 1-.367-.148L.178 4.085a.59.59 0 0 1-.036-.807.527.527 0 0 1 .77-.037l3.576 3.41L11.08.155a.528.528 0 0 1 .771.025.59.59 0 0 1-.023.808l-6.96 6.857A.53.53 0 0 1 4.494 8"/>
    </svg>
);

export const XCircleIcon: React.FC<IconProps> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90" className={className}>
        <g fill="none" fillRule="evenodd">
            <circle cx="45" cy="45" r="42" stroke="#E1E4E6" strokeWidth="6"/>
            <path fill="#E1E4E6" d="M49.243 45l13.435 13.435a3 3 0 0 1-4.243 4.243L45 49.243 31.565 62.678a3 3 0 0 1-4.243-4.243L40.757 45 27.322 31.565a3 3 0 0 1 4.243-4.243L45 40.757l13.435-13.435a3 3 0 0 1 4.243 4.243L49.243 45z"/>
        </g>
    </svg>
);

export const ModalVIcon: React.FC<IconProps> = ({ className  }) => (
    <svg width="126px" height="126px" viewBox="0 0 126 126" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <polygon id="path-1" points="125.999874 1.79056769e-14 0 1.79056769e-14 0 125.999811 125.999874 125.999811 125.999874 0"/>
        </defs>
        <g id="얼럿_모달" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" className={className}>
            <g id="alert_3_성공모달" transform="translate(-449.000000, -223.000000)">
                <g id="Group" transform="translate(272.000000, 134.000000)">
                    <g id="modal_v" transform="translate(177.000000, 89.000000)">
                        <g id="Clip-2"/>
                        <path d="M86.889474,43.104411 L57.901284,77.448231 L40.993344,58.809051 C40.048344,57.767661 38.431764,57.683241 37.382814,58.620681 C36.333234,59.558751 36.248814,61.162731 37.193814,62.204751 L56.011914,82.949391 C57.287664,84.225141 58.856994,83.933451 59.907834,82.883241 L90.758304,46.331271 C91.655424,45.269091 91.516824,43.685271 90.448344,42.793821 C89.379864,41.903001 87.786594,42.041601 86.889474,43.104411 M62.999874,120.959811 C30.989574,120.959811 5.039874,95.010741 5.039874,62.999811 C5.039874,30.989511 30.989574,5.039811 62.999874,5.039811 C95.010174,5.039811 120.959874,30.989511 120.959874,62.999811 C120.959874,95.010741 95.010174,120.959811 62.999874,120.959811 M62.999874,-0.000189 C28.206234,-0.000189 -0.000126,28.206171 -0.000126,62.999811 C-0.000126,97.794081 28.206234,125.999811 62.999874,125.999811 C97.794144,125.999811 125.999874,97.794081 125.999874,62.999811 C125.999874,28.206171 97.794144,-0.000189 62.999874,-0.000189" id="Fill-1" fill="#FFFFFF" mask="url(#mask-2)"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const BackIcon: React.FC<IconProps> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path fill="none" fillRule="evenodd" stroke="#878D91" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 4l-7 6 7 6" className={className} />
    </svg>
);

export const ChangeIcon: React.FC<IconProps> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd" transform="translate(4 6)" className={className}>
            <path stroke="#1BBF83" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 0l4 4-4 4"/>
            <rect width="2" height="10" x="4" y="-1" fill="#1BBF83" rx="1" transform="rotate(90 5 4)"/>
        </g>
    </svg>
);

export const MinusIcon: React.FC<IconProps> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <rect
            width="2"
            height="10"
            x="9"
            y="5"
            fill="#FF5D5D"
            fillRule="evenodd"
            rx="1"
            transform="rotate(90 10 10)"
            className={className}
        />
    </svg>
);

export const PlusIcon: React.FC<IconProps> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="#4C81F1" fillRule="evenodd" transform="translate(5 5)" className={className}>
            <rect width="2" height="10" x="4" rx="1"/>
            <rect width="2" height="10" x="4" rx="1" transform="rotate(90 5 5)"/>
        </g>
    </svg>
);

export const CloseIcon: React.FC<IconProps> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path fill="#A9AFB3" fillRule="evenodd" d="M11.75 10l7.875 7.875c.5.5.5 1.25 0 1.75s-1.25.5-1.75 0L10 11.75l-7.875 7.875c-.5.5-1.25.5-1.75 0s-.5-1.25 0-1.75L8.25 10 .375 2.125c-.5-.5-.5-1.25 0-1.75s1.25-.5 1.75 0L10 8.25 17.875.375c.5-.5 1.25-.5 1.75 0s.5 1.25 0 1.75L11.75 10z"/>
    </svg>
);

export const LockIcon: React.FC<IconProps> = ({ className }) => (
    <svg className={className} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M23 21.5135C23 14.0502 29.0442 8 36.5 8C43.9558 8 50 14.0502 50 21.5135V33H43.25V21.5135C43.25 17.7819 40.2279 14.7568 36.5 14.7568C32.7721 14.7568 29.75 17.7819 29.75 21.5135V33H23V21.5135Z" fill="#669EFF"/>
        <rect x="14" y="27" width="45" height="36" rx="4" fill="#A6C6FF"/>
        <circle cx="36" cy="42.5" r="3.5" fill="#669EFF"/>
        <path d="M33.9 45H38.1L39.2608 50.8039C39.3845 51.4227 38.9112 52 38.2802 52H33.7198C33.0888 52 32.6155 51.4227 32.7392 50.8039L33.9 45Z" fill="#669EFF"/>
    </svg>
);
